const e = {
  add: "Lisää",
  cancel: "Peruuta",
  clear: "Tyhjennä",
  confirm: "Vahvista",
  delete: "Poista",
  redo: "Tee uudelleen",
  save: "Tallenna",
  saveAs: "Tallenna nimellä",
  undo: "Kumoa"
}, a = {
  clear: "Tyhjennä",
  confirm: "Vahvista",
  datePlaceholder: "Valitse päivämäärä",
  datetimePlaceholder: "Valitse päivämäärä ja kellonaika",
  endDatePlaceholder: "Päättymispäivä",
  endDatetimePlaceholder: "Päättymispäivä ja -kellonaika",
  endMonthPlaceholder: "Päättymiskuukausi",
  monthPlaceholder: "Valitse kuukausi",
  now: "Nyt",
  quarterPlaceholder: "Valitse vuosineljännes",
  selectDate: "Valitse päivämäärä",
  selectTime: "Valitse kellonaika",
  startDatePlaceholder: "Alkamispäivä",
  startDatetimePlaceholder: "Alkamispäivä ja -kellonaika",
  startMonthPlaceholder: "Alkamiskuukausi",
  today: "Tänään",
  weekPlaceholder: "Valitse viikko",
  yearPlaceholder: "Valitse vuosi"
}, t = {
  placeholder: "Valitse"
}, l = {
  clear: "Tyhjennä",
  negativeText: "Peruuta",
  now: "Nyt",
  placeholder: "Valitse kellonaika",
  positiveText: "OK"
}, i = {
  placeholder: "Lisää"
}, s = {
  placeholder: "Lisää"
}, o = {
  placeholder: "Aloita kirjoittaminen..."
}, n = {
  allRows: "Kaikki rivit",
  default: "Oletus",
  deleteLayoutDescription: "Haluatko varmasti poistaa tämän asettelun?",
  discardChanges: "Hylkää muutokset",
  discardLayoutChanges: "Hylkää asettelumuutokset",
  enterLayoutName: "Anna asettelun nimi",
  enterRowNumber: "Anna rivien lukumäärä",
  fieldsSelected: "kenttää valittu",
  freezeColumnDescription: "Lukitse vasemmanpuoleinen sarake",
  freezeUptoColumn: "Lukitse sarakkeeseen asti",
  frozen: "Lukittu",
  layoutName: "Asettelun nimi",
  manageColumns: "Hallitse sarakkeita",
  none: "Ei mitään",
  reorderRows: "Järjestä rivit uudelleen",
  rowsSelected: "riviä valittu",
  saveLayoutAs: "Tallenna asettelu nimellä",
  saveLayoutNew: "Tallenna uusi asettelu",
  search: "Haku",
  searchColumnsPlaceholder: "Hakusarakkeet",
  searchFieldsPlaceholder: "Hakukentät",
  selectAll: "Valitse kaikki",
  setTableHeight: "Aseta pöydän korkeus",
  unfreeze: "Poista lukitus",
  unsavedChanges: "Sinulla on tallentamattomia muutoksia",
  unsavedChangesDescription: "Tallentamattomia muutoksia saattaa olla yksi tai useampi. Haluatko tallentaa ne?"
}, r = {
  at: "klo",
  colorAlreadyUsed: "Valitse eri sävy tai käytä olemassa olevaa",
  colorNamePlaceholder: "Lisää nimi",
  customPlaceholder: "{{ Custom }}",
  nameAlreadyUsed: "Valitse toinen värin nimi",
  noColorsAdded: "Sinulla ei ole värejä tässä osiossa."
}, u = {
  searchPlaceholder: "Haku"
}, d = {
  invalidPastedData: "Virheelliset liitetyt tiedot"
}, c = {
  of: "/",
  page: "Sivu",
  rowsPerPage: "Rivejä per sivu"
}, k = {
  failedToUpload: "Lataus epäonnistui",
  retry: "Yritä uudelleen",
  clickToUpload: "napsauttaa Ladataan",
  orDragAndDrop: "Tai Vetää ja pudota",
  supportedFileTypes: "Tuetut tiedostotyypit:"
}, m = {
  global: e,
  DatePicker: a,
  Select: t,
  TimePicker: l,
  Input: i,
  InputNumber: s,
  InputTag: o,
  HLDataTable: n,
  ColorPicker: r,
  InputPhone: u,
  InputOtp: d,
  Pagination: c,
  Upload: k
};
export {
  r as ColorPicker,
  a as DatePicker,
  n as HLDataTable,
  i as Input,
  s as InputNumber,
  d as InputOtp,
  u as InputPhone,
  o as InputTag,
  c as Pagination,
  t as Select,
  l as TimePicker,
  k as Upload,
  m as default,
  e as global
};
